import axios from 'axios'
import { notificationSuccess } from '../../../utils/customToastify'
import moment from 'moment'

import { GET_SYSTEM, CHANGED_SYSTEM_VALUE } from './types'

export const getSystem = () => async (dispatch) => {
  try {
    const response = await axios.get(`/system-config/`)
    let formatedResult = {}
    response.data.data.map((i) => {
      formatedResult[i.divisionId || 15] = { ...i }
    })

    dispatch({
      type: GET_SYSTEM,
      payload: formatedResult,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const systemHandleChange = (event, divisionId, selectName) => async (dispatch) => {
  const name = event.target ? event.target.name : selectName
  let value = event.target ? event.target.value : event.value
  if (name === 'taskPastDueTime') {
    const formatedTime = new Date(0, 0, 0, moment(value).format('HH'), 0, 0)
    value = moment(formatedTime).format('HH')
  }
  const changedSystemObject = {
    divisionId: divisionId || null,
    [name]: value || null,
  }
  dispatch({
    type: CHANGED_SYSTEM_VALUE,
    payload: changedSystemObject,
  })
}

export const saveSystemData = (data) => async () => {
  let formatedData = []
  Object.values(data).forEach((element) => {
    formatedData.push({ ...element })
  })
  await axios.post('system-config', formatedData)
  notificationSuccess('Data is saved')
}
